import { gql } from "generated-graphql";

export const SERC_AGENCY_FRAGMENT = gql(/* GraphQL */ `
  fragment SercAgencyFragment on SercAgency {
    id
    state
    recipient
    email
    streetAddress1
    streetAddress2
    city
    zip
    submitsViaEmail
    submitsViaPortal
    submitsViaForm
  }
`);

export const GET_SERC_AGENCIES = gql(/* GraphQL */ `
  query sercAgencies(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    sercAgencies(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      items {
        ...SercAgencyFragment
      }
      count
    }
  }
`);

export const GET_SERC_AGENCY_BY_STATE = gql(/* GraphQL */ `
  query sercAgencyByState($state: String!) {
    sercAgencyByState(state: $state) {
      ...SercAgencyFragment
    }
  }
`);

export const GET_SERC_AGENCY = gql(/* GraphQL */ `
  query sercAgency($id: String!) {
    sercAgency(id: $id) {
      ...SercAgencyFragment
    }
  }
`);

export const CREATE_SERC_AGENCY = gql(/* GraphQL */ `
  mutation createSercAgency($input: SercAgencyInput!) {
    createSercAgency(input: $input) {
      ...SercAgencyFragment
    }
  }
`);

export const UPDATE_SERC_AGENCY = gql(/* GraphQL */ `
  mutation updateSercAgency($id: String!, $input: SercAgencyInput!) {
    updateSercAgency(id: $id, input: $input) {
      ...SercAgencyFragment
    }
  }
`);

export const DELETE_SERC_AGENCY = gql(/* GraphQL */ `
  mutation deleteSercAgency($id: String!) {
    deleteSercAgency(id: $id) {
      id
      state
    }
  }
`);
